import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button, Box, IconChevronRight } from '@zillow/constellation';

var _excluded = ["children", "href", "target"];
function ArrowBlockButton(_ref) {
  var children = _ref.children,
    href = _ref.href,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_blank' : _ref$target,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({
    as: "a",
    variant: "secondary",
    href: href,
    target: target,
    fluid: true,
    icon: /*#__PURE__*/React.createElement(IconChevronRight, null),
    iconPosition: "end"
  }, rest), /*#__PURE__*/React.createElement(Box, {
    sx: {
      flex: 1,
      textAlign: 'left'
    }
  }, children));
}

export { ArrowBlockButton as default };
